import { siteConfig } from '@/configs/siteConfig';

import { siteState } from '@/modules/siteState/siteStateGetter';
import { easeInOutSine } from '@/modules/utils/easingUtils';

const props = {
  className: 'js-scrollTo',
  removeIsClassList: ['is-menuOpen'] as string[],
  extraOffset: 30,
  extraOffsetFixedNav: 40,
  duration: 600,
} as const;

const state = {
  click: {
    handler: undefined as ((e: MouseEvent) => void) | undefined,
  },

  rafId: null as number | null,

  isDisabledOnce: false,
};

export const smoothScroll = {
  init() {
    this.click();
  },

  reset() {
    this.removeClick();
  },

  getTriggerClassName() {
    return props.className;
  },
  disableOnce() {
    state.isDisabledOnce = true;
  },

  click() {
    if (state.click.handler) return;

    state.click.handler = (e: MouseEvent) => {
      // ### RUN ###
      this.clickHandler(e);
      // ### RUN END ###
    };

    document.addEventListener('click', state.click.handler);
  },
  clickHandler(e: MouseEvent) {
    if (state.isDisabledOnce) {
      state.isDisabledOnce = false;
      return;
    }

    const originEl = e.target;
    if (!(originEl instanceof HTMLElement)) return;

    const triggerEl = originEl.closest(`.${props.className}`);
    if (!(triggerEl instanceof HTMLElement)) return;

    const href = triggerEl.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    const target = href === '#' ? document.documentElement : document.querySelector(href);
    if (!target) return;

    const offsetAttr = triggerEl.getAttribute('data-offset');
    const hasOffsetAll = triggerEl.hasAttribute('data-offset-all');
    const hasOffsetShift = triggerEl.hasAttribute('data-offset-shift');
    const hasFixedNav = triggerEl.hasAttribute('data-fixed-nav');

    let offset = 0;
    const useHeaderOffset =
      //
      hasOffsetAll || //
      (hasOffsetShift && siteState.winWidth < siteConfig.breakpoint.shiftPoint);

    if (offsetAttr !== null) {
      offset = parseInt(offsetAttr, 10) || 0;
    } else if (useHeaderOffset) {
      offset = siteState.headerHeight + props.extraOffset;
    }

    let targetY = target.getBoundingClientRect().top + siteState.scrollY - offset;

    if (
      hasFixedNav && //
      siteState.winWidth < siteConfig.breakpoint.shiftPoint &&
      targetY < siteState.scrollY
    ) {
      targetY -= props.extraOffsetFixedNav;
    }

    e.preventDefault();

    this.removeIsClass();
    this.scrollTo(targetY);
  },
  removeClick() {
    if (!state.click.handler) return;

    document.removeEventListener('click', state.click.handler);
    state.click.handler = undefined;
  },

  scrollTo(targetY: number) {
    if (state.rafId !== null) {
      cancelAnimationFrame(state.rafId);
      state.rafId = null;
    }

    const startY = siteState.scrollY;
    const distance = targetY - startY;
    const startTime = performance.now();

    const loop = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / props.duration, 1);
      const eased = easeInOutSine(progress);

      window.scrollTo(0, startY + distance * eased);

      if (progress < 1) {
        state.rafId = requestAnimationFrame(loop);
      } else {
        state.rafId = null;
      }
    };

    state.rafId = requestAnimationFrame(loop);
  },

  removeIsClass() {
    [...document.documentElement.classList].forEach((className) => {
      if (className.startsWith('is-') && props.removeIsClassList.includes(className)) {
        document.documentElement.classList.remove(className);
      }
    });
  },
};
